module.exports = __webpack_public_path__ + "f572638f/img/mention-icon.8b3452e6.svg";